import {
    DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP,
    DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP_RESPONSE,
    DASHBOARD_PANEL_GADGET_CHART_DATA,
    DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE,
    DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST,
    DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT,
    CLEAR_REDUX
} from "Redux/actionTypes";

const INITIAL_STATE = {
    loadingcharts: false,
    charts_data: [],
    developers: [],
    loadingDevelopers: false
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case DASHBOARD_PANEL_GADGET_CHART_DATA:
            return {
                ...state,
                charts_data: [],
                loadingcharts: true
            };

        case DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE:
            return {
                ...state,
                charts_data: action.payload,
                loadingcharts: false
            };

        case DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST:
            return {
                ...state,
                loadingDevelopers: true
            };

        case DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT:
            return {
                ...state,
                loadingDevelopers: false,
                developers: action.payload
            };

        case CLEAR_REDUX:
            return ["", "DASHBOARD_PANEL_GADGET_CHART"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INITIAL_STATE }
                : state;

        default:
            return state;
    }
};